<template>
    <router-view></router-view>
</template>

<script>
export default {
    data() {
        return {
            plans: [],
        }
    },

    mounted() {
        this.getAvailablePlans();
    },

    methods: {
        getAvailablePlans() {
            axios.get('api/users/subscriptions/available-plans', {
                params: {
                    'vault_id': this.$route.params.vault_id,
                }
            })
                .then(({data}) => {
                    let plans = {};
                    _.each(data, (plan) => {
                        _.set(plans, `${plan.name}.${plan.interval}`, plan);
                    });
                    this.$store.commit('setPlans', plans);
                });
        },
    },
}
</script>

<style>

</style>
